import React from 'react';
import { BookOpenIcon, GraduationCapIcon, ScissorsIcon, SchoolIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { audience } from '../../data/content';
const icons = [ScissorsIcon, GraduationCapIcon, BookOpenIcon, SchoolIcon];
const tints = ['#F7CDBE', '#D3E5CC', '#CDE0F1', '#DFD0F2'];
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-47" data-mp="286t2j6oxesyw">
      <div className="mx-auto max-w-5xl" data-id="element-48" data-mp="237yb5gcw7w36">
        <SectionHeading id="audience-heading" title={<>
              Conçu pour les professionnels qui <Accent data-id="element-50" data-mp="2h17fv3pwbtfd">transmettent leur savoir-faire</Accent>
            </>} data-id="element-49" data-mp="236x0ve3pbdmi" />

        <ul className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-4" role="list" data-id="element-51" data-mp="2czm9803ygbdm">
          {audience.map((item, index) => {
          const Icon = icons[index];
          return <li key={item} className="flex flex-col items-center rounded-[20px] bg-white px-4 py-7 text-center" data-id="element-52" data-mp="2lzr2758ej789" data-mpi={index}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full" style={{
              backgroundColor: tints[index]
            }} data-id="element-53" data-mp="1sdoxy2kz3al6">
                  <Icon className="h-5 w-5 text-brand-charcoal" strokeWidth={1.5} aria-hidden="true" data-id="element-54" data-mp="228gud32tjred" />
                </span>
                <span className="mt-4 font-body text-[12px] font-bold uppercase leading-snug tracking-[0.1em] text-brand-charcoal sm:text-[13px]" data-id="element-55" data-mp="2bagazu9x8tgs">
                  {item}
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-56" data-mp="2l1kp6rrrwaak">
          Que vous animiez des ateliers techniques ou des programmes plus complets, ces ressources vous aident à
          structurer votre enseignement.
        </p>
      </div>
    </section>;
}